import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function splitTextSteps(value: string | null | undefined): string[] {
  if (!value) return [];

  return value
    .split(/\r?\n/)
    .map(line => line.trim())
    .map(line => line.replace(/^(?:\d+[.):-]?|[-*])\s*/, ''))
    .filter(Boolean);
}

export function formatNumberedSteps(value: string | null | undefined, preserveTrailingBlank = false): string {
  if (!value) return '';

  const lines = value.replace(/\r\n/g, '\n').split('\n');
  const formatted: string[] = [];
  let stepNumber = 1;

  lines.forEach((line, index) => {
    const step = line.trim().replace(/^(?:\d+[.):-]?|[-*])\s*/, '');

    if (!step) {
      const isTrailingBlank = preserveTrailingBlank && index === lines.length - 1;
      if (isTrailingBlank) {
        formatted.push(`${stepNumber}. `);
      }
      return;
    }

    formatted.push(`${stepNumber}. ${step}`);
    stepNumber += 1;
  });

  return formatted.join('\n');
}

/** Format a number as currency */
export function formatCurrency(value: number, symbol = '$', decimals = 2): string {
  return `${symbol}${value.toFixed(decimals)}`;
}

/** Format a number as a percentage */
export function formatPct(value: number, decimals = 1): string {
  return `${value.toFixed(decimals)}%`;
}

/** Format grams */
export function formatGrams(value: number): string {
  if (value >= 1000) return `${(value / 1000).toFixed(2)} kg`;
  return `${value.toFixed(1)} g`;
}
